import { render, staticRenderFns } from "./StaticContentFormModal.vue?vue&type=template&id=153be5be"
import script from "./StaticContentFormModal.vue?vue&type=script&lang=js"
export * from "./StaticContentFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports